import { Button } from "@mui/material";
import React from "react";
import { Event } from "@mui/icons-material";
import useResponsive from "../../hooks/useResponsive";

interface AddWorkshopInstanceButtonProps {
  setIsAddWorkshopInstanceDialogOpen: (isOpen: boolean) => void;
}

/**
 * Displays a button to open a dialog to add a workshop instance.
 * @param setIsAddWorkshopInstanceDialogOpen Function to set the state of the dialog.
 * @returns A button to open a dialog to add a workshop instance.
 */
const AddWorkshopInstanceButton: React.FunctionComponent<AddWorkshopInstanceButtonProps> = ({
  setIsAddWorkshopInstanceDialogOpen,
}: AddWorkshopInstanceButtonProps) => {
  const isMobile = useResponsive("down", "sm");

  const handleOpen = () => {
    setIsAddWorkshopInstanceDialogOpen(true);
  };

  return (
    <>
      {isMobile ? (
        <Button variant="contained" onClick={handleOpen} startIcon={<Event />} sx={{ fontSize: 10 }} color="info">
          Termin hinzufügen
        </Button>
      ) : (
        <Button
          variant="contained"
          color="info"
          sx={{ fontWeight: 600, mr: 2 }}
          onClick={handleOpen}
          startIcon={<Event />}
          size="small"
        >
          Termin hinzufügen
        </Button>
      )}
    </>
  );
};

export default AddWorkshopInstanceButton;
